<template>
    <div class="container mt-0">
        <div id="section-to-print" class="instruction">
            <div class="row text-left step">
                <div class="col-md-6">
                    <h1>{{video.title}}</h1>
                    <p class="text-grey">{{ video.description }}</p>
                </div>
                <div class="col-md-6">
                    <iframe width="100%" height="300px" :src="video.url" frameborder="0"></iframe>
                </div>
            </div>
            <div class="row py-2 text-left step" v-for="(step, index) in video.instructions" :key="index" :class="{'bg-white': !(index%2)}">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-2">
                            <div class="step-number">{{index + 1}}</div>
                        </div>
                        <div class="col-10">
                            <h4>{{step.sub_title}}</h4>
                        </div>
                    </div>
                    <div class="co-md-12 offset-md-2">
                        <ul>
                            <li v-for="(item, index) in step.items" :key="index">
                                <span class="text-grey">{{ item }}</span></li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <img :src="require('@/assets/images/instructions/' + step.image)" width="100%" alt="">
                </div>
            </div>
        </div>
        <div class="row p-3 navigation">
            <div class="col-4 px-1">
                <w-button class="w-100" id="prev" :to="{ path: prevUrl }">Previous</w-button>
            </div>
            <div class="col-4 px-1">
                <w-button class="w-100" id="all" :to="{ path: '/help' }">View All</w-button>
            </div>
            <div class="col-4 px-1">
                <w-button class="w-100" id="next" :to="{ path:nextUrl }">Next</w-button>
            </div>
        </div>
    </div>
</template>

<script>
import videos from '@/assets/json/videos'

export default {
    props: ['id'],
    computed: {
        video () {
            return videos.find(item => item.id === parseInt(this.$route.params.id))
        },
        nextUrl () {
            let index = videos.findIndex(item => item.id === parseInt(this.video.id))
            return index === videos.length - 1 ? `/help/${videos[0].id}` : `/help/${videos[index + 1].id}`
        },
        prevUrl () {
            let index = videos.findIndex(item => item.id === parseInt(this.video.id))
            return index === 0 ? `/help/${videos[videos.length - 1].id}` : `/help/${videos[index - 1].id}`
        }
    }
}
</script>

<style scoped>
    .step-number {
        width: 30px;
        height: 30px;
        background-color: #2fc2ef;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        line-height: 30px;
    }

    @media (min-width: 576px) {
        ul {
            padding-left: 0;
        }
    }

    ul li {
        list-style: disc;
    }

    .text-grey {
        color: #898989;
    }
</style>
